import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import {
  AlbumCell,
  AlbumCellProps,
  AppBar,
  LoadMoreSpinner,
  ScrollArrows,
  SvgIcon,
} from '../../../Molecules';

import styles from './RecentAlbumListTemplate.module.css';

export type RecentAlbumListTemplateProps = {
  albumData: AlbumCellProps[];
  hasCursor: boolean;
  loadMoreItems: () => void;
};

export const RecentAlbumListTemplate = memo(
  ({ albumData, hasCursor, loadMoreItems }: RecentAlbumListTemplateProps) => {
    const { t } = useTranslation();

    return (
      <div className={styles.recentAlbumList}>
        <div className={styles.centeredContainer}>
          <ScrollArrows />
          <AppBar title={t('Recently Played')} withBack={true} />

          <div className={styles.listView}>
            {albumData.length === 0 ? (
              <div className={styles.emptyContainer}>
                <SvgIcon
                  name={SVGIconType.PracticeTick}
                  className={styles.emptyAlbumIcon}
                />
                <div className={styles.emptyAlbumText}>
                  {t('No Recently Played Memory Practice')}
                </div>
              </div>
            ) : (
              albumData.map((item, index) => (
                <AlbumCell key={index} {...item} />
              ))
            )}
          </div>
          {hasCursor && (
            <LoadMoreSpinner
              hasCursor={hasCursor}
              loadMoreItems={loadMoreItems}
            />
          )}
        </div>
      </div>
    );
  },
);
